"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFailureModeNullableSlot = exports.getFailureModeSlot = exports.getFailureModeAlarm = exports.checkAlarmOnExpirableConsumable = exports.checkAlarmOnExpendableConsumable = exports.checkAlarmOnDepletableConsumable = exports.makeCatalogue = exports.makeActiveAlarms = exports.makeEmptySlots = exports.makeSlottedConsumables = exports.makeSlottedConsumable = void 0;
exports.supportsConsumables = supportsConsumables;
exports.getLocation = getLocation;
const effect_1 = require("effect");
const alarm_1 = require("../capability/alarm");
const active_alarm_1 = require("./active-alarm");
const failure_mode_1 = require("./failure-mode");
const slotted_consumable_1 = require("./slotted-consumable");
const makeSlottedConsumable = (slotTuple) => effect_1.Schema.NullOr(effect_1.Schema.Union(...effect_1.Tuple.map(slotTuple, ConsumableConstructor => effect_1.Schema.Struct({
    subset: ConsumableConstructor,
    state: ConsumableConstructor.State,
}))));
exports.makeSlottedConsumable = makeSlottedConsumable;
const makeSlottedConsumables = (slotsDef) => effect_1.Schema.Tuple(...effect_1.Tuple.map(slotsDef, exports.makeSlottedConsumable));
exports.makeSlottedConsumables = makeSlottedConsumables;
const makeEmptySlots = (slotsDef) => effect_1.Tuple.map(slotsDef, () => null);
exports.makeEmptySlots = makeEmptySlots;
function supportsConsumables(device) {
    return device.slots.length > 0;
}
const makeActiveAlarms = (alarms) => effect_1.Schema.Array(active_alarm_1.ActiveAlarm.omit('alarm').pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
    alarm: effect_1.Schema.Union(...effect_1.Array.flatten(effect_1.Record.values(alarms))),
}))));
exports.makeActiveAlarms = makeActiveAlarms;
const makeCatalogue = (slots) => effect_1.Schema.Tuple(...effect_1.Tuple.map(slots, consumables => effect_1.Schema.Array(effect_1.Schema.Union(...consumables))));
exports.makeCatalogue = makeCatalogue;
const checkAlarmOnDepletableConsumable = (consumable, slotIndex) => {
    if (consumable && (0, slotted_consumable_1.isDepletable)(consumable)) {
        if (consumable.state.level <= consumable.subset.rangeExhaust.amount)
            return new alarm_1.ConsumableDepleted({
                params: {
                    consumableId: consumable.subset.constructor.id,
                    subsetId: consumable.subset.id,
                    index: slotIndex,
                },
            });
        if (consumable.state.level < consumable.subset.rangeTrigger.amount)
            return new alarm_1.ConsumableLowLevel({
                params: {
                    consumableId: consumable.subset.constructor.id,
                    subsetId: consumable.subset.id,
                    index: slotIndex,
                },
            });
    }
    return null;
};
exports.checkAlarmOnDepletableConsumable = checkAlarmOnDepletableConsumable;
const checkAlarmOnExpendableConsumable = (consumable, slotIndex) => {
    if (consumable &&
        (0, slotted_consumable_1.isExpendable)(consumable) &&
        consumable.state.usage > consumable.subset.rangeExhaust.amount)
        return new alarm_1.ConsumableOverused({
            params: {
                consumableId: consumable.subset.constructor.id,
                subsetId: consumable.subset.id,
                index: slotIndex,
            },
        });
    return null;
};
exports.checkAlarmOnExpendableConsumable = checkAlarmOnExpendableConsumable;
const checkAlarmOnExpirableConsumable = (consumable, slotIndex) => {
    if (consumable && (0, slotted_consumable_1.isExpirable)(consumable) && consumable.state.expiresAt.getTime() < Date.now())
        return new alarm_1.ConsumableExpired({
            params: {
                consumableId: consumable.subset.constructor.id,
                subsetId: consumable.subset.id,
                expirationDate: consumable.state.expiresAt,
                index: slotIndex,
            },
        });
    return null;
};
exports.checkAlarmOnExpirableConsumable = checkAlarmOnExpirableConsumable;
const getFailureModeAlarm = (alarms, constructor) => {
    return failure_mode_1.FailureModeCases.Alarm({
        subject: alarms.find(effect_1.Schema.is(effect_1.Schema.instanceOf(constructor))) ?? null,
        constructor,
    });
};
exports.getFailureModeAlarm = getFailureModeAlarm;
const getFailureModeSlot = (subject) => {
    return failure_mode_1.FailureModeCases.Slot({ subject, constructor: subject.subset.constructor });
};
exports.getFailureModeSlot = getFailureModeSlot;
const getFailureModeNullableSlot = (subject, constructor) => {
    return failure_mode_1.FailureModeCases.Slot({ subject, constructor });
};
exports.getFailureModeNullableSlot = getFailureModeNullableSlot;
/**
 * Returns the {@link Option.Option Option}-wrapped `location` on `device.state`, if available.
 */
function getLocation(device) {
    return 'location' in device.state ? effect_1.Option.fromNullable(device.state.location) : effect_1.Option.none();
}
//# sourceMappingURL=_util.js.map